var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"head",attrs:{"src":require("../../assets/images/1304/header.png"),"alt":""}})])
}]

export { render, staticRenderFns }